//import node_modules
import React, { FunctionComponent } from "react";

//libs
import { TOTAL_BLOGS_PER_PAGE } from "src/templates/blogs/[page]/types";

//components
import PagingComponent from "src/components/pagination/PaginationComponent";
import usePagination from "src/components/pagination/hooks/usePaginationHandler";

type RouterProps = {
  page: number;
  total: number;
};

function pathGenerator(page: number) {
  return `/blogs/${page}/`;
}

const RouterComponent: FunctionComponent<RouterProps> = ({ page, total }) => {
  const handler = usePagination(pathGenerator, page, total, TOTAL_BLOGS_PER_PAGE);
  return <PagingComponent handler={handler} maxButtons={5} />;
};

export default React.memo(RouterComponent);
